import { render, staticRenderFns } from "./RoundsReportList.vue?vue&type=template&id=20fd7d0a"
import script from "./RoundsReportList.vue?vue&type=script&lang=js"
export * from "./RoundsReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports